var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['widget-item button-widget ', { 'auto-fit-text': _vm.widget.object.maximalTextSize }],style:(_vm.style),attrs:{"id":_vm.widget.object.wid},on:{"click":function($event){$event.preventDefault();return _vm.showImage.apply(null, arguments)}}},[_c('span',{class:['button-text']},[_vm._v(_vm._s(_vm.widget.object.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }